export function getContainerSelected(state) {
    return state.containerSelected;
  }
  export function getContainer(state) {
    return state.containers;
  }
  